
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.213 2.009a1 1 0 01-.067 1.085 4.833 4.833 0 006.76 6.76 1 1 0 011.59.896A8.5 8.5 0 119.25 1.504a1 1 0 01.963.505zm-2.72 1.975a6.5 6.5 0 108.523 8.523 6.832 6.832 0 01-8.523-8.523z"}})])
          )
        }
      }
    